import Vue from "vue";
import VueRouter from "vue-router";
import App from "./App.vue";
import NotFound from "./components/NotFound.vue";
import FederationSeries from "./components/FederationSeries.vue";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import moment from "moment";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faCalendarCheck,
  faListOl,
  faFutbol
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import vueHeadful from "vue-headful";
import ApexCharts from "apexcharts";

//component to set title
Vue.component("vue-headful", vueHeadful);

//library for charts
Vue.component("apexcharts", ApexCharts);

//locale to dutch
moment.locale("nl");

Vue.config.productionTip = false;

//routing
Vue.use(VueRouter);
var router = new VueRouter({
  mode: "history",
  routes: [
    { path: "/:series", 
      component: FederationSeries,
      props(route) {
        return {
          federation: 'kvdv',
          series: route.params.series
        }
      }
    },
    {
      path: "/:series/:team",
      component: FederationSeries,
      props(route) {
        return {
          federation: 'kvdv',
          series: route.params.series,
          team: route.params.team
        }
      }
    },
    { path: "/404", component: NotFound },
    { path: "*", redirect: "/zat2" }
  ]
});

//date/time formatting filters
Vue.filter("formatDate", function(value) {
  if (value) {
    return moment(String(value)).format("DD-MM-YY");
  }
});

Vue.filter("formatTime", function(value) {
  if (value) {
    return moment(String(value)).format("HH:mm");
  }
});

Vue.filter("formatDayName", function(value) {
  if (value) {
    return moment(String(value)).format("ddd");
  }
});

Vue.filter("capitalize", function(value) {
  if (!value) return "";
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
});

//fontawesome
library.add(faCalendarCheck);
library.add(faFutbol);
library.add(faListOl);

Vue.component("font-awesome-icon", FontAwesomeIcon);

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
